import { Chart } from '@frontend/chart/types';

export const FILL_RATE_BY_PRODUCT_MONTHLY_LIST_CHART_MOCK_DATA: Chart = {
    series: [
        {
            name: 'Safety gloves',
            data: [
                { label: '2026-07-01', value: 88 },
                { label: '2026-08-01', value: 112 }
            ]
        },
        {
            name: 'Ear protection',
            data: [
                { label: '2026-07-01', value: 102 },
                { label: '2026-08-01', value: 105 }
            ]
        },
        {
            name: 'Work boots',
            data: [
                { label: '2026-07-01', value: 95 },
                { label: '2026-08-01', value: 78 }
            ]
        },
        {
            name: 'Hi-vis vest',
            data: [
                { label: '2026-07-01', value: 70 },
                { label: '2026-08-01', value: 42 }
            ]
        },
        {
            name: 'Hard hat',
            data: [
                { label: '2026-07-01', value: 60 },
                { label: '2026-08-01', value: 65 }
            ]
        },
        {
            name: 'Dust mask',
            data: [
                { label: '2026-07-01', value: 50 },
                { label: '2026-08-01', value: 33 }
            ]
        }
    ]
};
